import HeroBreadCrumb from "../../components/BreadCrumb/HeroBreadCrumb";
import ContactForm from "../../components/ContactForm/ContactForm";
import Paragraph from "../../components/Paragraph/Paragraph";
import SectionBanner from "../../components/SectionBanner/SectionBanner";
import { ContactContent } from "./Contact-Content";

const Contact: React.FC = () => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        const form = event.currentTarget;
        const first_name = form.elements.namedItem('c_fname') as HTMLInputElement;
        const last_name = form.elements.namedItem('c_lname') as HTMLInputElement;
        const email = form.elements.namedItem('c_email') as HTMLInputElement;
        const subject = form.elements.namedItem('c_subject') as HTMLTextAreaElement;
        const message = form.elements.namedItem('c_message') as HTMLTextAreaElement;
    
        const mailtoLink = `mailto:support@raykos.com?subject=${encodeURIComponent(
          subject.value || 'Contact Form Submission'
        )}&body=${encodeURIComponent(
          `Name: ${first_name.value + ' ' + last_name.value}\nEmail: ${email.value}\nMessage: ${message.value}`
        )}`;
    
        window.location.href = mailtoLink;
    };
    return (
      <>
        <HeroBreadCrumb
          content={ContactContent.heroBreadCrumb}
          style={{ minHeight: "21.875rem" }}
        />
        <section className="container py-4">
          <Paragraph isPageHeader={true} content={ContactContent.paragraph1} />
        </section>
        <section className="container py-4">
            <iframe
                title="gmapt-hyderabad"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.25176871577!2d78.40804555!3d17.4123487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana%2C%20India!5e0!3m2!1sen!2sus!4v1688930090842!5m2!1sen!2sus"
                width="100%"
                height="450"
                style={{border: 0}}
                loading="eager"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </section>
        <section className="container py-4">
          <ContactForm
            content={ContactContent.contactForm}
            onSubmit={handleSubmit}
          />
        </section>
        <SectionBanner
          linkClass="bg-light-grey2 py-4"
          content={ContactContent.sectionBanner}
        />
      </>
    );
};

export default Contact;